import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Container = styled.div<{
  fitToContents?: boolean;
  $containerWidth?: string;
}>`
  ${(props) => {
    if (props.fitToContents) {
      return;
    }
    return {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'start',
      width: props.$containerWidth || '100%',
    };
  }}
`;

export const FormInputLabel = styled.label<{ disabled?: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${({ theme, disabled }) =>
    disabled
      ? theme.atlas.semantic.color.type.muted
      : theme.atlas.semantic.color.type.default};
  overflow: hidden;
  text-overflow: ellipsis;
  height: 25px;
`;

export const RequiredText = styled.span<{ disabled?: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${({ theme, disabled }) =>
    disabled
      ? theme.atlas.semantic.color.type.muted
      : theme.atlas.semantic.color.type.default};
  padding-left: 4px;
`;

export const FormInputDescription = styled.p<{ hasMarginTop?: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  ${(props) => props.hasMarginTop && 'margin-top: 8px;'}
`;

export const FormInputLabelContainer = styled.div<{
  hasMarginBottom?: boolean;
}>`
  display: flex;
  gap: 8px;
  align-items: center;
  ${(props) => (props.hasMarginBottom ? 'margin-bottom: 8px;' : '')}
`;
